// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Antd = require("antd");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var ReactUtils$SmartcutsMacros = require("../../packages/bs-utils/src/ReactUtils.bs.js");

var errorAlert = CssJs.style([
      CssJs.maxWidth(CssJs.px(700)),
      CssJs.margin("auto")
    ]);

var Styles = {
  errorAlert: errorAlert
};

function ErrorMessage(Props) {
  var error = Props.error;
  return React.createElement(Antd.Alert, {
              description: React.createElement(React.Fragment, undefined, ReactUtils$SmartcutsMacros.s("Something went wrong. Please contact "), React.createElement("a", {
                        href: "mailto:support@trysmartcuts.com"
                      }, ReactUtils$SmartcutsMacros.s("support@trysmartcuts.com"))),
              message: React.createElement("strong", undefined, ReactUtils$SmartcutsMacros.s("Error. "), ReactUtils$SmartcutsMacros.s(error)),
              showIcon: true,
              type: "error",
              className: errorAlert
            });
}

var make = ErrorMessage;

exports.Styles = Styles;
exports.make = make;
/* errorAlert Not a pure module */
